import { Injectable } from '@angular/core';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ItemLogDataService } from 'src/app/services';
import { handleError } from 'src/app/state/akita-error-helper';
import { CollectionState } from 'src/app/state/collection-state';
import { ItemLog } from 'src/app/models/domain';

@Injectable({ providedIn: 'root' })
export class ItemLogService {
  private readonly state = new CollectionState<ItemLog>();

  public readonly itemLogs$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(private readonly itemLogDataService: ItemLogDataService) {}

  public loadByDesignId(designId: string): Observable<void> {
    this.state.setLoading(true);

    return this.itemLogDataService.getItemLogsByDesignId(designId).pipe(
      tap((itemLogs) => {
        this.state.set(itemLogs);
      }),
      catchError((error) => {
        handleError(this.state, error);

        return NEVER;
      }),
      map(() => undefined)
    );
  }
}
